import { useMemo, useState } from "react";
import { Compass, Ticket, Sparkles } from "lucide-react";

/**
 * Lightweight, skippable first-run walkthrough.
 * Shown as an overlay so the user can still land on Home immediately.
 */
export default function Onboarding({ onDone }) {
    const slides = useMemo(
        () => [
            {
                icon: <Sparkles size={24} />,
                title: "Welcome to Beach Bum Pass",
                body: "Your quick way to discover Emerald Coast activities � without digging through pages of info.",
            },
            {
                icon: <Compass size={24} />,
                title: "Discover",
                body: "Browse activities, tap a card for details, and save ideas for your trip.",
            },
            {
                icon: <Ticket size={24} />,
                title: "My Pass",
                body: "Your pass lives here. Schedule it, check status, and pull it up fast when you need it.",
            },
        ],
        []
    );

    const [index, setIndex] = useState(0);
    const isLast = index === slides.length - 1;

    const next = () => setIndex((i) => Math.min(i + 1, slides.length - 1));
    const back = () => setIndex((i) => Math.max(i - 1, 0));

    return (
        <div className="ob-backdrop" role="dialog" aria-modal="true">
            <div className="ob-card">
                <button className="ob-skip" onClick={onDone} type="button">
                    Skip
                </button>

                <div className="ob-icon">{slides[index].icon}</div>
                <h2 className="ob-title">{slides[index].title}</h2>
                <p className="ob-body">{slides[index].body}</p>

                <div className="ob-dots" aria-label="Walkthrough progress">
                    {slides.map((_, i) => (
                        <span key={i} className={`ob-dot ${i === index ? "active" : ""}`} />
                    ))}
                </div>

                <div className="ob-actions">
                    <button className="ob-btn secondary" onClick={back} type="button" disabled={index === 0}>
                        Back
                    </button>

                    {isLast ? (
                        <button className="ob-btn" onClick={onDone} type="button">
                            Get Started
                        </button>
                    ) : (
                        <button className="ob-btn" onClick={next} type="button">
                            Next
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
